import { useEffect } from 'react'
import {
  NotebookText, LifeBuoy, HeartHandshake, Eye,
  Globe, Users, BookOpen, TrendingUp, Pill, CalendarCheck,
  Camera, ListChecks, LineChart, FolderOpen,
} from 'lucide-react'
import './Landing.css'

const DEMO_BOOKING_URL = 'https://calendar.app.google/bhRPKXmsYN519vFq5'

const WHATSAPP_NUMERO = '5491168882293'
const WHATSAPP_MENSAJE = 'Hola! me interesa saber más de juco.'
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(WHATSAPP_MENSAJE)}`

const FEATURES_NUTRI = [
  { Icono: Globe, titulo: 'Tu propia marca, tu propio dominio', texto: 'Cada nutricionista tiene su espacio con su paleta, su logo y su nombre.' },
  { Icono: Users, titulo: 'Todos tus pacientes en un solo lugar', texto: 'Sin planillas sueltas ni conversaciones perdidas entre apps.' },
  { Icono: BookOpen, titulo: 'Cargá contenido, recetas y planes', texto: 'Tu material queda organizado y disponible para cada paciente.' },
  { Icono: TrendingUp, titulo: 'Mirá el progreso en tiempo real', texto: 'Lo que tu paciente carga, vos lo ves apenas lo registra.' },
  { Icono: Pill, titulo: 'Hábitos y suplementos personalizados', texto: 'Armá rutinas propias por paciente, no un mismo molde para todos.' },
  { Icono: CalendarCheck, titulo: 'Gestioná membresías y consultas', texto: 'Todo el ciclo del paciente, desde un solo panel.' },
]

const FEATURES_PACIENTE = [
  { Icono: Camera, titulo: 'Diario de comidas con foto', texto: 'Registra lo que come con contexto real, no solo un número.' },
  { Icono: ListChecks, titulo: 'Hábitos y suplementos para tildar', texto: 'Su rutina del día, armada por su nutri, lista para marcar.' },
  { Icono: LineChart, titulo: 'Su progreso, compartido con su nutri', texto: 'Ve su propia evolución al mismo tiempo que la ve su nutri.' },
  { Icono: FolderOpen, titulo: 'Contenido de su nutri en un solo lugar', texto: 'Recetas, planes y clases, sin buscar en cinco lados distintos.' },
  { Icono: LifeBuoy, titulo: 'Acompañamiento en los momentos difíciles', texto: 'El S.O.S. está ahí cuando el proceso se hace cuesta arriba.' },
]

// Glyph de WhatsApp (Simple Icons, CC0) — es una excepción deliberada a la
// paleta de marca Juco: el verde/blanco de WhatsApp es lo que hace
// reconocible al botón como acceso directo al chat, no un elemento de
// theming de la app.
const PILARES_ACOMPANAMIENTO = [
  {
    Icono: NotebookText,
    titulo: 'Un diario, no una planilla',
    texto: 'Registra sus comidas con foto y contexto, no solo números para cumplir.',
  },
  {
    Icono: LifeBuoy,
    titulo: 'Ayuda en el momento justo',
    texto: 'El S.O.S. está para los días difíciles, no solo para los que van bien.',
  },
  {
    Icono: HeartHandshake,
    titulo: 'Hábitos que se sostienen',
    texto: 'Rutinas armadas a su medida, para tildar día a día, sin presión.',
  },
  {
    Icono: Eye,
    titulo: 'Nunca sola en el proceso',
    texto: 'Todo lo que carga, vos lo ves, el acompañamiento no depende de que te escriba.',
  },
]

function IconoWhatsapp() {
  return (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
    </svg>
  )
}

export default function Landing() {
  // Libera el carril de 430px pensado para la PWA mobile (App.css) mientras
  // la landing está montada — mismo patrón que body.admin-mode en AdminApp.js.
  useEffect(() => {
    document.body.classList.add('landing-mode')
    return () => document.body.classList.remove('landing-mode')
  }, [])

  const scrollAPaneles = (e) => {
    e.preventDefault()
    document.getElementById('landing-paneles')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="landing-page">
      <a href="/login" className="landing-ingresar">Ingresar</a>

      {/* 1. HERO */}
      <section className="landing-hero">
        <img src="/logo-transparente.png" alt="Juco" className="landing-hero-logo" />
        <p className="landing-eyebrow">Procesos nutricionales y cambio de hábito</p>
        <h1 className="landing-h1">Más pacientes, la misma cercanía.</h1>
        <p className="landing-subtitulo">Ideal si trabajás con membresías o grupos.</p>
        <div className="landing-cta-row">
          <a
            href={DEMO_BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primario landing-btn"
          >
            Agendar una demo
          </a>
          <a href="#landing-paneles" onClick={scrollAPaneles} className="landing-btn-ghost">
            Ver cómo funciona
          </a>
        </div>
      </section>

      {/* PROBLEMA — contexto antes de la frase puente */}
      <section className="landing-problema">
        <p>
          Hoy gestionás pacientes entre 3 o 4 apps distintas, herramientas genéricas
          que no llevan tu marca, y datos que solo ves si el paciente te manda una
          foto o un mensaje. Eso no es seguimiento real.
        </p>
      </section>

      {/* 2. FRASE PUENTE */}
      <section className="landing-puente">
        <p>“Las apps genéricas no fueron pensadas para vos ni para tus pacientes. Juco sí.”</p>
      </section>

      {/* 3. DOS PANELES, UNA SOLA APP */}
      <section className="landing-paneles" id="landing-paneles">
        <div className="landing-panel">
          <h2 className="landing-panel-titulo">Panel de la nutricionista</h2>
          <ul className="landing-panel-lista">
            {FEATURES_NUTRI.map(({ Icono, titulo, texto }) => (
              <li key={titulo} className="landing-feature">
                <Icono className="landing-feature-icono" size={22} strokeWidth={1.75} aria-hidden="true" />
                <div>
                  <p className="landing-feature-titulo">{titulo}</p>
                  <p className="landing-feature-texto">{texto}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="landing-panel">
          <h2 className="landing-panel-titulo">Panel de la paciente</h2>
          <ul className="landing-panel-lista">
            {FEATURES_PACIENTE.map(({ Icono, titulo, texto }) => (
              <li key={titulo} className="landing-feature">
                <Icono className="landing-feature-icono" size={22} strokeWidth={1.75} aria-hidden="true" />
                <div>
                  <p className="landing-feature-titulo">{titulo}</p>
                  <p className="landing-feature-texto">{texto}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ACOMPAÑAMIENTO — Juco no es solo tracking, el paciente se siente
          sostenido en el proceso. Inspirado en el bloque humano/de valores
          de nutreando.com/software, con contenido propio de Juco. */}
      <section className="landing-acompanamiento">
        <h2 className="landing-acompanamiento-titulo">Detrás de cada dato, una persona</h2>
        <p className="landing-acompanamiento-subtitulo">
          Juco no es solo seguimiento, es un espacio donde tu paciente se siente
          acompañada en cada etapa, no juzgada por un número.
        </p>
        <div className="landing-pilares">
          {PILARES_ACOMPANAMIENTO.map(({ Icono, titulo, texto }) => (
            <div className="landing-pilar" key={titulo}>
              <Icono className="landing-pilar-icono" size={28} strokeWidth={1.75} aria-hidden="true" />
              <h3 className="landing-pilar-titulo">{titulo}</h3>
              <p className="landing-pilar-texto">{texto}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 4. CTA INTERMEDIO */}
      <section className="landing-cta-banda">
        <p>¿Querés ver cómo se ve esto en la práctica?</p>
        <a
          href={DEMO_BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primario landing-btn"
        >
          Agendar una demo
        </a>
      </section>

      {/* 5. FOOTER */}
      <footer className="landing-footer">
        <p className="landing-footer-frase">Más pacientes, la misma cercanía.</p>
        <div className="landing-cta-row">
          <a
            href={DEMO_BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primario landing-btn"
          >
            Agendar una demo
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="landing-btn-ghost"
          >
            Contactanos por WhatsApp
          </a>
        </div>
      </footer>

      {/* Flotante, acompaña el scroll — acceso directo, no depende de llegar al footer. */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="landing-whatsapp-flotante"
        aria-label="Escribinos por WhatsApp"
      >
        <IconoWhatsapp />
      </a>
    </div>
  )
}
